var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-down-text"},[_c('p',[_vm._v("scroll down")]),_vm._v(" "),_c('div',{staticClass:"scroll-down-text__arrow"})])}]

export { render, staticRenderFns }